import { render, staticRenderFns } from "./ordersettle.vue?vue&type=template&id=0e23dcf0&scoped=true"
import script from "./ordersettle.vue?vue&type=script&lang=js"
export * from "./ordersettle.vue?vue&type=script&lang=js"
import style0 from "./ordersettle.vue?vue&type=style&index=0&id=0e23dcf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23dcf0",
  null
  
)

export default component.exports